import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { BaseSearchModel } from '../../../../Data/Models/Common/base-search-model';
import { CharitiesFilterModel } from '../../../../Data/Models/Common/charities-filter-model';
import { LocalStorageService } from '../../../../Shared/common/local-storage.service';
import { CharityDetailsModal } from '../addcharities/CharityDetailsModal';

@Injectable({
  providedIn: 'root'
})
export class CharityDataShareServiceService {
  charityFilterDetails: CharitiesFilterModel|null;

  flag: boolean = false;
  private userName: BehaviorSubject<string> = new BehaviorSubject<string>(localStorage.getItem('SubmittedUsername') ?? '');
  userName$ = this.userName.asObservable()

  private charityListSubject: BehaviorSubject<BaseSearchModel<CharityDetailsModal >|null> = new BehaviorSubject<BaseSearchModel<CharityDetailsModal>|null>(null);
  charityList = this.charityListSubject.asObservable();

  private charitygriddata: BehaviorSubject<BaseSearchModel<CharityDetailsModal> | null> = new BehaviorSubject<BaseSearchModel<CharityDetailsModal> | null>(null);
  charitygrid = this.charitygriddata.asObservable();

  public showPopup$ = new BehaviorSubject<boolean>(true);
  // Flag to track if validation popup already shown this session
  private hasValidated = false;

  private finalStatus = new BehaviorSubject<string>(localStorage.getItem('apFinalised') ?? '');
  finalStatus$ = this.finalStatus.asObservable()
  private renew = new BehaviorSubject<boolean>(false);
  Renewpopup = this.renew.asObservable()
  private Expired = new BehaviorSubject<boolean>(false);
  Expiredpopup = this.Expired.asObservable();

  financial_Year = localStorage.getItem('financial_Year');
  private FY_YearMethod = new BehaviorSubject<string>(this.financial_Year == null ? '' : this.financial_Year);
  FY_Year$ = this.FY_YearMethod.asObservable();

  CurrentAP_ID: number = +(localStorage.getItem('currentPeriod')??0);
  private CurrentAP_IDMethod = new BehaviorSubject<number>(this.CurrentAP_ID == null ? 0 : this.CurrentAP_ID);
  CurrentAP_ID$ = this.CurrentAP_IDMethod.asObservable();

  AP_SubmitedDate: number = +(localStorage.getItem('currentPeriod') ?? 0);
  private AP_SubmitedDateMethod = new BehaviorSubject<number>(this.AP_SubmitedDate == null ? 0 : this.AP_SubmitedDate);
  AP_SubmitedDate$ = this.AP_SubmitedDateMethod.asObservable();

  accounting_Method = localStorage.getItem('accounting_Method');
  private AccountMethodType_method = new BehaviorSubject<string>(this.accounting_Method == null ? '' : this.accounting_Method)
  AccountMethodType$ = this.AccountMethodType_method.asObservable();



  ReportType_Method = localStorage.getItem('ReportType_Method');
  private ReportType_method = new BehaviorSubject<string>(this.ReportType_Method == null ? '' : this.ReportType_Method)
  ReportTypeMethod$ = this.ReportType_method.asObservable();

   charity_Name = localStorage.getItem('charity_Name');
  private CharityNameMethod = new BehaviorSubject<string>(this.charity_Name == null ? '' : this.charity_Name)
  CharityName$ = this.CharityNameMethod.asObservable();

  charity_Registration_Number = localStorage.getItem('charity_Registration_Number');  
  private CharityRegistraionNumbMethod = new BehaviorSubject<string>(this.charity_Registration_Number == null ? '' : this.charity_Registration_Number)
  CharityRegistraionNumber$ = this.CharityRegistraionNumbMethod.asObservable()

  private charitySubNoteListSubject = new BehaviorSubject<SubNoteList[]>([]);
  CharitySubNoteList$ = this.charitySubNoteListSubject.asObservable();

  private isLoadingResultsMethod = new BehaviorSubject<boolean>(false)
  isLoadingResults$ = this.isLoadingResultsMethod.asObservable()

  constructor(private lsService: LocalStorageService) {
    debugger
    const storedValue = sessionStorage.getItem('hasValidatedLicensePopup');
    this.showPopup$.next(storedValue !== 'true');
    if (localStorage.getItem('currentPeriod')) {
      document.body.classList.add('currentperiod')
    }

  }
   setuserName(name: any) {
    this.userName.next(name)
  }
  setFinalStatus(status: string) {
   this.finalStatus.next(status);
  }
  updateFY_Year(newValue: string) {
    this.FY_YearMethod.next(newValue);
  }
  UpdateCurrentAP_ID(newValue: number) {
    this.CurrentAP_IDMethod.next(newValue);
  }
  UpdateAP_SubmitedDate(newValue: number) {
    this.AP_SubmitedDateMethod.next(newValue);
  }
  updateAccountMethodType(newValue: string) {
    this.AccountMethodType_method.next(newValue);
  }
  updateAccountReportType(newValue: string) {
    this.ReportType_method.next(newValue);
  }

  updateCharityRegistraionNumb(NextVale: string) {
    this.CharityRegistraionNumbMethod.next(NextVale)
    if (NextVale == '') { localStorage.setItem('charity_Registration_Number',''); }
  }
  updateSubNoteList(newList: SubNoteList[]): void {
    this.charitySubNoteListSubject.next(newList);
  }
  updateCharityName(NextVale: string) {
    this.CharityNameMethod.next(NextVale)
  }
  updateisLoadingResults(NextVale: boolean) {
    this.isLoadingResultsMethod.next(NextVale)
  }
  charites: any
  setCharityList(charityList: BaseSearchModel<CharityDetailsModal>) {
    debugger
    this.charityListSubject.next(charityList);
  }
  canValidate(): boolean {
    if (sessionStorage.getItem('renewpopup') == 'true') {
      return false
    }
    else if (sessionStorage.getItem('renewpopup')) {
      return true
    }
    else if (sessionStorage.getItem('renewpopup') !== 'true') {
      return true
    }
    else {
      return true
    }
   
  }
  TrailbalanceTemplate() { debugger }
  SelectedAccountMethod() { debugger }
  markValidated(): void {
    sessionStorage.setItem('hasValidatedLicensePopup', 'true'); // Mark as validated
    this.showPopup$.next(false); // Hide popup after validation shown
  }

  resetValidation(): void {
    sessionStorage.removeItem('hasValidatedLicensePopup'); // Reset validation state
    this.showPopup$.next(true); // Show popup again
  }
  setExpiredpopup(flag: boolean) {
    this.Expired.next(flag)
  }
  setRenewpopup(flag: string) {
    sessionStorage.setItem('renewpopup', flag);
  }

  triggerAddCharityMethod = new Subject<void>();
  triggerveiwCharityMethod = new Subject<void>();
}
export interface SubNoteList {
  subNoteName: string,
  isActive: string,
  OrderID: any
}
